import { localize_utc_date, format_date } from '#lib/util.js';
import { event_days, parse_day } from '#lib/calendar_periods.js';

/**
 * Events that run longer than this many days (exhibitions) are listed once per period instead
 * of being drawn into every day they cover, where they would crowd out everything else.
 */
export const LONG_RUN_DAYS = 7;

/**
 * Each event with the local days it covers, earliest first.
 * @param {any[]} events - entry previews with starts_at / ends_at
 */
export function with_days(events) {
  return (events ?? [])
    .map(event => ({ event, days: event_days(event, localize_utc_date) }))
    .filter(item => item.days)
    .sort((a, b) => new Date(a.event.starts_at) - new Date(b.event.starts_at));
}

/** Number of local days an event covers (1 for a single day) */
export function day_span(days) {
  return Math.round((parse_day(days.last) - parse_day(days.first)) / 86400000) + 1;
}

export function is_long_running(days) {
  return day_span(days) > LONG_RUN_DAYS;
}

/** "19:00" or "19:00–21:00"; empty for all-day events */
export function time_label(event) {
  if (event.all_day || !event.starts_at) return '';
  const starts = new Date(event.starts_at);
  const start_time = format_date(starts, 'Hm');
  if (!event.ends_at) return start_time;
  const ends = new Date(event.ends_at);
  const same_day = localize_utc_date(starts).toISOString().slice(0, 10) === localize_utc_date(ends).toISOString().slice(0, 10);
  const end_time = format_date(ends, 'Hm');
  return same_day && end_time !== start_time ? `${start_time}–${end_time}` : start_time;
}
